/**
 * DTX — lazy-loads section scripts when markup nears the viewport.
 * Boots on idle so it does not compete with LCP / first interactions.
 */
(function () {
  if (window.__dtxScriptsLoaderBound) return;
  window.__dtxScriptsLoaderBound = true;

  const manifestEl = document.getElementById('dtx-script-manifest');
  if (!manifestEl) return;

  let manifest;
  try {
    manifest = JSON.parse(manifestEl.textContent || '{}');
  } catch {
    return;
  }

  const loaded = new Set();

  function loadScript(url) {
    if (!url || loaded.has(url)) return Promise.resolve();
    loaded.add(url);

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`DTX: failed to load ${url}`));
      document.body.appendChild(script);
    });
  }

  function observeEntry(entry, sharedObserver, pending) {
    const { selector, url } = entry;
    if (!selector || !url) return;

    const nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    const run = () => loadScript(url).catch(() => {});

    if (!sharedObserver) {
      run();
      return;
    }

    nodes.forEach((node) => {
      pending.set(node, run);
      sharedObserver.observe(node);
    });
  }

  function boot() {
    if (!Array.isArray(manifest.entries)) return;

    const pending = new Map();
    let sharedObserver = null;

    if ('IntersectionObserver' in window) {
      sharedObserver = new IntersectionObserver(
        (records) => {
          records.forEach((record) => {
            if (!record.isIntersecting) return;
            const run = pending.get(record.target);
            if (!run) return;
            pending.delete(record.target);
            sharedObserver.unobserve(record.target);
            // Coalesce script injection off the intersection callback stack.
            if ('requestIdleCallback' in window) {
              window.requestIdleCallback(run, { timeout: 800 });
            } else {
              window.setTimeout(run, 0);
            }
          });
        },
        { rootMargin: '180px 0px', threshold: 0.01 }
      );
    }

    manifest.entries.forEach((entry) => observeEntry(entry, sharedObserver, pending));
  }

  const schedule = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(boot, { timeout: 2200 });
    } else {
      window.setTimeout(boot, 350);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
